export enum StationDetailOption {
  METAR = "METAR",
  TAF = "TAF",
  FORECAST = "Forecast",
  NOTAM = "NOTAM",
  ATIS = "ATIS",
}

export const STATION_DETAIL_OPTIONS = [
  StationDetailOption.METAR,
  StationDetailOption.TAF,
  StationDetailOption.FORECAST,
  StationDetailOption.NOTAM,
  StationDetailOption.ATIS,
] as const;

